import { API_HOST } from '../../config';
import getEventFrame from '../../lib/get-event-frame';
import getPaymentMessage from '../../lib/get-payment-message';
import beginApplePaySession from './beginApplePaySession';
import { isFrameStartApplePayMessage } from './FrameApplePayMessage';
export default function applePay(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.apiHost, apiHost = _c === void 0 ? API_HOST : _c, _d = _b.frameOrigin, frameOrigin = _d === void 0 ? API_HOST : _d, onSendResponse = _b.onSendResponse;
    var handlePostMessage = function (e) {
        var message = getPaymentMessage(e.data);
        if (isFrameStartApplePayMessage(message)) {
            var _a = message.data, request = _a.request, merchantId = _a.merchantId, purchaseToken = _a.purchaseToken;
            var handleSendResponse = onSendResponse ||
                (function (m) {
                    var _a;
                    var iframe = getEventFrame(e);
                    (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(m, frameOrigin);
                });
            beginApplePaySession({
                request: request,
                merchantId: merchantId,
                purchaseToken: purchaseToken,
                apiHost: apiHost,
                onSendResponse: handleSendResponse
            });
        }
    };
    window.addEventListener('message', handlePostMessage);
    return function () {
        window.removeEventListener('message', handlePostMessage);
    };
}
